(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.accordionIsOpen = false;
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 989px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        document.documentElement.classList.add('shopify-section-header-always-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.nonAccordionNavItems = this.header.querySelectorAll('nav > ul > li > a');

      for (const navItem of this.nonAccordionNavItems) {
        navItem.addEventListener('mouseenter', this.closeAllAccordions.bind(this));
      }

      this.createObserver();
    }

    accordionOpened() {
      this.accordionIsOpen = true;
    }

    accordionClosed() {
      this.accordionIsOpen = false;
    }

    closeAllAccordions() {
      const accordions = this.header.querySelectorAll('simple-accordion');
      for (const accordion of accordions) {
        accordion.close();
      }
      this.accordionIsOpen = false;
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.querySelector('.header-wrapper').getBoundingClientRect().height}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.documentElement.classList.remove('shopify-section-header-sticky-reveal');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.documentElement.classList.add('shopify-section-header-sticky-reveal');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.documentElement.classList.remove('shopify-section-header-sticky-reveal');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal || typeof this.searchModal.close !== 'function') {
        return;
      }

      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infinite-image-scroll"] && !Shopify.designMode) return;
  try {
    
  class InfiniteImageScroll extends HTMLElement {
    constructor() {
      super();

      this.element = this;
      this.settings = JSON.parse(this.element.dataset.sectionSettings);

      this.lazyloadThreshold = this.settings.lazyload_threshold;
      this.sectionId = this.settings.section_id;
      this.startIndex = this.settings.start_index;
      this.endIndex = this.settings.end_index;
      this.frameCount = this.endIndex - this.startIndex;
      this.images = this.settings.images;
      this.preloadImageCount = this.settings.preloaded_image_count;
      this.objectFit = this.settings.object_fit;

      this.scrollIcon = this.element.querySelector('.scroll-icon-container') || null;
      this.textBlocks = this.element.querySelectorAll('.text-block');
      this.canvas = this.element.querySelector('#infinite-scroll-' + this.sectionId);
      this.loader = this.element.querySelector('.infinite-scroll-loader');

      this.sectionTop = this.element.closest('section').getBoundingClientRect().y;
      this.sectionBottom = this.sectionTop + this.element.closest('section').getBoundingClientRect().height;
      this.preloadedImages = [];
      this.previousFrameIndex = 0;
      this.currentFrameIndex = 0;
      this.pendingFrameIndex = 0;
      this.imageAspectRatio = null;
      this.scrollIconFaded = false;

      this.intersectionObserver = new IntersectionObserver(
        this.handleIntersection.bind(this),
        {
          rootMargin: `0px 0px ${ this.lazyloadThreshold * 10 }px 0px`
        }
      ).observe(this);
    }

    handleIntersection(entries, observer) {
      const section = entries[0];

      if (!section.isIntersecting) {
        return;
      }

      /* Reload section if changes have been made to it in the theme customizer */
      document.addEventListener('shopify:section:load', this.onSectionLoad.bind(this));

      /* After the initial Lazyload, we load the section */
      this.init();

      observer.unobserve(this);
    }

    onSectionLoad(event) {
      if (event.detail.sectionId === this.sectionId) {
        this.init(true);
      }
    }

    init(reload = false) {
      if (this.sequenceName === '') {
        return;
      }

      if (!reload) {
        this.preloadedImages.push({});
        this.preloadImages();
      } else {
        this.currentFrameIndex = 0;
      }

      window.addEventListener('resize', this.resizeCanvas.bind(this));
      window.addEventListener('scroll', this.changeFrame.bind(this));

      this.resizeCanvas();
    }

    preloadImages() {
      for (let i = 0; i < this.preloadImageCount - 1; i++) {
        const image = new Image();
        image.src = this.images[i];

        this.preloadedImages.push({
          index: i,
          image: image,
          loaded: false,
        });

        image.onload = (function () {
          this.preloadedImages[i].loaded = true;
          if (!this.imageAspectRatio) this.imageAspectRatio = image.height / image.width;
        }).bind(this); 
      }
    }

    draw() {
      const context = this.canvas.getContext('2d');

      if (this.preloadedImages.length > this.currentFrameIndex && this.currentFrameIndex !== 0) {
        this.drawAndFit(context, this.preloadedImages[this.currentFrameIndex].image, this.objectFit);
      } else {
        const image = new Image();
        const index = this.currentFrameIndex;
        image.src = this.images[index];

        image.onload = (function () {
          this.preloadedImages[index] = {
            index: index,
            image: image,
            loaded: true,
          };

          if (!this.imageAspectRatio) this.imageAspectRatio = image.height / image.width;
          this.drawAndFit(context, image, this.objectFit);
        }).bind(this);
      }
    }

    positionLoader() {
      if (this.objectFit !== 'contain' || !this.imageAspectRatio) {
        this.loader.style.cssText = '';
        return;
      }

      const canvasRect = this.canvas.getBoundingClientRect();
      const elementRect = this.element.getBoundingClientRect();

      const canvasW = canvasRect.width;
      const canvasH = canvasRect.height;
      const canvasAspect = canvasW / canvasH;
      const imageAspect = 1 / this.imageAspectRatio;

      var drawX, drawY, drawWidth, drawHeight;

      if (imageAspect > canvasAspect) {
        drawWidth = canvasW;
        drawHeight = canvasW * this.imageAspectRatio;
        drawX = 0;
        drawY = (canvasH - drawHeight) / 2;
      } else {
        drawHeight = canvasH;
        drawWidth = canvasH * imageAspect;
        drawX = (canvasW - drawWidth) / 2;
        drawY = 0;
      }

      this.loader.style.inset = 'auto';
      this.loader.style.top = ((canvasRect.top - elementRect.top) + drawY) + 'px';
      this.loader.style.left = ((canvasRect.left - elementRect.left) + drawX) + 'px';
      this.loader.style.width = drawWidth + 'px';
      this.loader.style.height = drawHeight + 'px';
      this.loader.style.borderRadius = '1.2rem';
    }

    showLoading() {
      this.positionLoader();
      this.loader.classList.add('is-loading');
    }

    hideLoading() {
      this.loader.classList.remove('is-loading');
    }

    drawAndFit(context, image, fitType) {
      const aspectRatio = image.height / image.width;
      const windowRatio = window.innerHeight / window.innerWidth;

      if (fitType === 'square') {
        const imageSize = Math.min(image.width, image.height);
        const left = (image.width - imageSize) / 2;
        const top = (image.height - imageSize) / 2;

        context.drawImage(image, left, top, imageSize, imageSize, 0, 0, context.canvas.width, context.canvas.height);
      } else if (fitType === 'contain') {
        let drawX, drawY, drawWidth, drawHeight;

        if (aspectRatio < windowRatio) {
          drawWidth = window.innerWidth;
          drawHeight = window.innerWidth * aspectRatio;
          drawX = 0;
          drawY = (window.innerHeight - drawHeight) / 2;
        } else {
          drawWidth = window.innerWidth * windowRatio / aspectRatio;
          drawHeight = window.innerHeight;
          drawX = (window.innerWidth - drawWidth) / 2;
          drawY = 0;
        }

        const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
        const borderRadius = rootFontSize * 1.2;

        context.clearRect(0, 0, context.canvas.width, context.canvas.height);
        context.save();
        context.beginPath();
        context.roundRect(drawX, drawY, drawWidth, drawHeight, borderRadius);
        context.clip();
        context.drawImage(image, drawX, drawY, drawWidth, drawHeight);
        context.restore();
      } else {
        if (aspectRatio > windowRatio) {
          const height = window.innerWidth * aspectRatio;

          context.drawImage(image, 0, (window.innerHeight - height) / 2, window.innerWidth, height);
        } else {
          const width = window.innerWidth * windowRatio / aspectRatio;

          context.drawImage(image, (window.innerWidth - width) / 2, 0, width, window.innerHeight);
        }
      }
    }

    changeFrame() {
      var instance = this; /* Note: var is needed because we are using this in requestAnimationFrame(), and Safari won't support const / let in there */
      const scrollTop = document.documentElement.scrollTop - this.sectionTop;
      const maxScrollTop = this.sectionBottom - this.sectionTop - this.canvas.height;

      if (scrollTop < 0 || scrollTop > maxScrollTop) {
        return;
      }

      const scrollFraction = scrollTop / maxScrollTop;
      var frameIndex = Math.min(this.frameCount - 1, Math.floor(scrollFraction * this.frameCount)); /* Same deal here as above */

      if (this.previousFrameIndex === frameIndex) {
        return; /* Avoid unnecessary redraws */
      }

      this.pendingFrameIndex = frameIndex;

      if (typeof this.preloadedImages[frameIndex] === 'undefined') {
        const minIndex = Math.max(0, frameIndex - this.preloadImageCount);
        const maxIndex = Math.min(this.frameCount - 1, frameIndex + this.preloadImageCount);

        this.showLoading();
        this.loadMissingFrames(minIndex, maxIndex); /* If the user scrolls too fast, load the bounding missing frames */

        return;
      }

      this.previousFrameIndex = this.currentFrameIndex;
      this.currentFrameIndex = frameIndex;

      this.updateBlocks();
      this.updateIcon();

      requestAnimationFrame(function () {
        var entry = instance.preloadedImages[frameIndex];

        if (entry.loaded) {
          instance.hideLoading();
          instance.drawAndFit(instance.canvas.getContext('2d'), entry.image, instance.objectFit);
        } else {
          var onImageLoad = function () {
            entry.image.removeEventListener('load', onImageLoad);
            if (instance.pendingFrameIndex === frameIndex) {
              instance.hideLoading();
              instance.drawAndFit(instance.canvas.getContext('2d'), entry.image, instance.objectFit);
            }
          };
          instance.showLoading();
          entry.image.addEventListener('load', onImageLoad);
        }

        if (instance.preloadedImages.length < frameIndex + instance.preloadImageCount) {
          const index = instance.preloadedImages.length;

          if (instance.images.length <= index) {
            return;
          }

          const image = new Image();
          image.src = instance.images[index];

          instance.preloadedImages.push({
            index: index,
            image: image,
            loaded: false,
          });

          image.onload = (function () {
            instance.preloadedImages[index].loaded = true;
            if (!instance.imageAspectRatio) instance.imageAspectRatio = image.height / image.width;
          }).bind(instance);
        }
      });
    }

    loadMissingFrames(minIndex, maxIndex) {
      for (let i = minIndex; i <= maxIndex; i++) {
        if (typeof this.preloadedImages[i] === 'undefined') {
          const image = new Image();
          image.src = this.images[i];

          image.onload = (function () {
            this.preloadedImages[i] = {
              index: i,
              image: image,
              loaded: true,
            };

            if (!this.imageAspectRatio) this.imageAspectRatio = image.height / image.width;

            if (i === this.pendingFrameIndex) {
              requestAnimationFrame((function () {
                this.hideLoading();
                this.drawAndFit(this.canvas.getContext('2d'), image, this.objectFit);
              }).bind(this));
            }
          }).bind(this);
        }
      }
    }

    updateBlocks() {
      for (const block of this.textBlocks) {
        const fadeInIndex = Number(block.dataset.fadeInIndex);
        const fadeOutIndex = Number(block.dataset.fadeOutIndex);
        const isIncreasing = this.currentFrameIndex > this.previousFrameIndex;

        if (this.currentFrameIndex > fadeInIndex && this.currentFrameIndex < fadeOutIndex && block.classList.contains('is-visible')) {
          continue; /* We have the block visible, and we are still in the faded-in range, so we don't need to do anything */
        }

        /* Note: .is-visible is just a control class (see the condition above), and has no styling to it */
        if (isIncreasing) {
          if (this.currentFrameIndex >= fadeInIndex && this.previousFrameIndex < fadeInIndex) {
            block.classList.add('is-visible');
            block.classList.add('fade-in');

            block.classList.remove('fade-out-to-top');
            block.classList.remove('fade-out-to-bottom');
          }

          if (this.currentFrameIndex >= fadeOutIndex && this.previousFrameIndex < fadeOutIndex) {
            block.classList.remove('is-visible');
            block.classList.add('fade-out-to-top');

            block.classList.remove('fade-in');
          }
        } else {
          if (this.currentFrameIndex <= fadeOutIndex && this.previousFrameIndex > fadeOutIndex) {
            block.classList.add('is-visible');
            block.classList.add('fade-in');

            block.classList.remove('fade-out-to-top');
            block.classList.remove('fade-out-to-bottom'); 
          }

          if (this.currentFrameIndex <= fadeInIndex && this.previousFrameIndex > fadeInIndex) {
            block.classList.remove('is-visible');
            block.classList.add('fade-out-to-bottom');

            block.classList.remove('fade-in');
          }
        }
      }
    }

    updateIcon() {
      if (!this.scrollIcon || this.scrollIconFaded) {
        return;
      }

      const fadeOutIndex = Number(this.scrollIcon.dataset.fadeOutIndex);

      if (this.currentFrameIndex >= fadeOutIndex) {
        this.scrollIcon.classList.add('faded');
        this.scrollIconFaded = true;
      }
    }

    resizeCanvas() {
      this.sectionTop = this.element.closest('section').offsetTop;
      this.sectionBottom = this.sectionTop + this.element.closest('section').getBoundingClientRect().height;

      if (this.objectFit === 'square' && window.innerWidth > 749) {
        this.canvas.width = window.innerWidth / 2;
        this.canvas.height = window.innerWidth / 2;
      } else if (this.objectFit === 'square' && window.innerWidth <= 749) {
        this.canvas.width = window.innerWidth;
        this.canvas.height = window.innerWidth;
      } else {
        this.canvas.width = window.innerWidth;
        this.canvas.height = window.innerHeight;
      }

      this.draw();
    }
  }

  customElements.define('infinite-image-scroll', InfiniteImageScroll);

  } catch(e) { console.error(e); }
})();
})();
